import React from 'react'
import PropTypes from 'prop-types'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'

const DoxExplorerTitleBar = ({ textKey, params}) => {
    const translateString = useTranslationContext()    

    return (
        <div className='doxe-titlebar hrb-columns'>
            <h4>{translateString(textKey, params)}</h4>
        </div>
    )
}

DoxExplorerTitleBar.propTypes = {
    textKey: PropTypes.string.isRequired,
    params: PropTypes.object
}   

export default DoxExplorerTitleBar;